import { CreateChatbotDrawer } from './create-chatbot-drawer.component';

export default CreateChatbotDrawer;
